// capture_note — free-text note saved on the run (write_to) for later steps.
import React, { useState } from 'react';
import { StickyNote } from 'lucide-react';
import { StepCard, StepNav } from './_stepKit';

export default function CaptureNote({ action, value, onChange, onNext, onBack, canBack }) {
  const p = action.params || {};
  const [text, setText] = useState(typeof value === 'string' ? value : '');
  return (
    <div>
      <StepCard icon={StickyNote} title={p.label || 'Note'} testid="wf-capture-note">
        {p.prompt && <div className="text-sm text-slate-600">{p.prompt}</div>}
        <textarea rows={4} value={text} data-testid="wf-capture-note-input"
          onChange={(e) => { setText(e.target.value); onChange(e.target.value); }}
          className="w-full border border-slate-300 rounded p-2 text-sm focus:border-sky-500 outline-none"
          placeholder="Type the note… (leave blank to skip)" />
      </StepCard>
      <StepNav canBack={canBack} onBack={onBack} onNext={() => onNext(text)} label={text.trim() ? 'Save & next →' : 'Skip →'} />
    </div>
  );
}
